/*
 * vue-router navigation helpers.
 *
 * The router is created in routes.js, which imports every route component - so a component
 * importing routes.js back would be a cycle. This holds a reference instead; `setRouter` is called
 * by main.js at boot. It replaces the `$state`/`router` half of the vue-services bridge (step 41 of
 * #614); none of the ui-router fallbacks are needed because there is only one router now.
 */
let router = null

export function setRouter(theRouter) {
  router = theRouter
}

export function goToResources() {
  if (router) {
    router.push('/').catch(() => {})
  } else {
    window.location.assign('/')
  }
}

export function goToRoute(path, query) {
  if (router) {
    router.push({ path: path, query: query || {} }).catch(() => {})
  } else {
    window.location.assign(path)
  }
}

export function goToSettingsTab(tab) {
  goToRoute(`/settings/${tab}`)
}

export function goToApp(redirect) {
  if (redirect) {
    // A saved redirect is a URL, so it gets a full load rather than a router hop.
    window.location.assign(redirect)
    return
  }

  goToResources()
}

export default { setRouter, goToResources, goToRoute, goToSettingsTab, goToApp }
